import { Accordion, Box, Flex, ScrollArea, Stack, Text } from "@mantine/core"
import SingleCustomerContext from "../Customer-Context/SingleCustomerContext";
import { useContext, useEffect, useState, useRef } from "react";
import { DARK_GREY_TEXT} from "../../../constants/colors";
import CustomerAccordionItem from "./CustomerAccordionItem";
import { IconX } from "@tabler/icons";

const CustomersAccordions = () => {
  const [openedAccordion, setOpenedAccordion] = useState<string | null>(null);
  const [initialLoad, setInitialLoad] = useState(true);
  const scrollAreaRef = useRef<HTMLDivElement>(null);

  const { 
    chosenIdea,
    setLoadingEvidence,
    customers,
    setCardOpened,
    setChosenEvidence,
    setActivityOpened
  } = useContext(SingleCustomerContext);

  const togglePanel = () => {

    setCardOpened((prev: boolean) => !prev);
    setChosenEvidence(null)
    setActivityOpened(false)
  };

  const scrollToElement = (customerId: string) => {
    setTimeout(() => {
      if (scrollAreaRef.current) {
        const element = document.querySelector(`[data-customer-id="${customerId}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, 1280); // 3 second delay
  };

  const isOnlyEvidence = chosenIdea?.status === 'evidence'
  const prevChosenIdeaRef = useRef(chosenIdea);

  const evidences = chosenIdea?.evidences || []
  // Get orgIds from evidences array.
  const relatedOrgIds = evidences?.map((evidence: any) => evidence?.orgId) || []
  const relatedCustomers = customers?.filter((customer: any) => relatedOrgIds?.includes(customer?._id))

  useEffect(() => {
    const hasChosenIdeaChanged = prevChosenIdeaRef.current !== chosenIdea;
    if ((initialLoad || hasChosenIdeaChanged) && relatedCustomers?.length === 1) {
      setOpenedAccordion(`${relatedCustomers[0]?._id}-${chosenIdea?._id}`);
      setInitialLoad(false);
      setLoadingEvidence(true);
    }
    prevChosenIdeaRef.current = chosenIdea;
  }, [relatedCustomers, initialLoad, chosenIdea]);

  return (
    <ScrollArea ref={scrollAreaRef} h='calc(100vh - 151px)' mah='calc(100vh - 151px)' type="always">
      <Flex justify='space-between' align='center'>
        <Text px={36}  mt={16} fz={10} color={DARK_GREY_TEXT}>
        CUSTOMERS' EVIDENCES
        </Text>
        {isOnlyEvidence && <Stack
          align="center"
          justify="center"
          pt={4}
          mr={25}
          sx={{ cursor: "pointer" }}
          onClick={togglePanel}
        >
          <IconX size={14} color="#5C5CEB" />
        </Stack>}
      </Flex>
      
      <Box p={16}>
        
        <Accordion value={openedAccordion} onChange={setOpenedAccordion}>
          <CustomerAccordionItem 
            relatedCustomers={relatedCustomers} 
            evidences={evidences} 
            scrollToElement={scrollToElement}
          />
        </Accordion>

      </Box>
      
    </ScrollArea>
  )
}

export default CustomersAccordions